import React from 'react';
import styled from 'styled-components';

import burger from '../images/Burger.png';
import responsiveLogo from '../images/logo-mobile.svg';
import createSwap from '../images/CreateSwap.svg';
import { useHistory, Link } from 'react-router-dom';

import { useIconSwapService } from './IconSwapService.jsx';

export const ResponsiveNav = ({
  showNav,
  showLogin,
}: ResponsiveNavPropTypes) => {
  const { address } = useIconSwapService();
  const history = useHistory();

  const navigationFunction = () => {
    if (!address) {
      return showLogin();
    }
    return history.push('/createSwap');
  };
  return (
    <ResponsiveNavWrapper>
      <Link to={'/'} style={{ textDecoration: 'none' }}>
        <LogoImage src={responsiveLogo} alt="IconSwap" />
      </Link>
      <AlignRightWrapper>
        <PlusImage src={createSwap} alt="Add" onClick={navigationFunction} />
        <BurgerImage src={burger} alt="Burger" onClick={showNav} />
      </AlignRightWrapper>
    </ResponsiveNavWrapper>
  );
};

export default ResponsiveNav;

const ResponsiveNavWrapper = styled.div`
  width: 415px;
  height: 74px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const LogoImage = styled.img`
  height: 30px;
  width: 128px;
  margin-left: 20px;
`;

const AlignRightWrapper = styled.div`
  margin-left: auto;
`;

const PlusImage = styled.img`
  height: 30px;
  width: 30px;
  margin-right: 30px;
`;

const BurgerImage = styled.img`
  width: 20px;
  height: 16px;
  margin-right: 20px;
`;

type ResponsiveNavPropTypes = {
  showNav: () => void;
  showLogin: () => void;
};
